<template>
  <div class="connect-box" v-if="props.type == '2-3'">
    <div class="suggestion-block" v-if="hasSuggestions">
      <svg-icon name="alert" class="suggestion-icon" />
      <div class="suggestion-text">
        <span>Suggested connections:</span>
        <template v-for="(item, idx) in RegisterStore.verifityList" :key="idx">
          <span v-if="item.handle">
            {{ item.name }}: {{ item.handle.startsWith('@') ? item.handle : '@' + item.handle }}
          </span>
        </template>
      </div>
    </div>
    <div class="connect-line" v-for="(item, index) in RegisterStore.verifityList" :key="index">
      <div class="social">
        <svg-icon :name="item.icon" />
        <div class="name">{{ item.default_handle ? item.default_handle : item.name }}</div>
      </div>
      <div class="connect-btn-box">
        <el-button type="primary" @click="connectPopup(item)" v-if="(item.default_handle && !item.connect_status) || !item.default_handle">Connect</el-button>
        <el-button v-if="item.connect_status" @click="openDisConnectDialog(item)">Disconnect</el-button>
      </div>
    </div>
  </div>
  <div class="handle-select-box">
    <HandleSelector ref="handleSelectorRef" @updateHandle="updateHandle" v-if="props.type == '2-4'" />
  </div>
  <!-- 詢問要多連哪一個 -->
  <el-dialog v-model="dialogVisible" :title="`Connect your account(s)`" class="connect-list-dialog">
    <el-scrollbar>
      <div class="connect-box">
        <div class="connect-line" v-for="(item, index) in store.initSocial" :key="index" v-show="item.show">
          <div class="social">
            <svg-icon :name="item.icon" />
            <div class="name">{{ item.name }}</div>
          </div>
          <el-button type="primary" @click="connectPopup(item, 'spec')">Connect</el-button>
        </div>
      </div>
    </el-scrollbar>
  </el-dialog>

  <DisConnectDialog ref="disConnectDialogRef" @disConnect="handleDisconnect(disConnectItem)" />
  <!-- 連接條款 -->
  <ConnectSocialDialog v-model:dialogValue="dialogConnectValue" :need_token="true" :is_more_register="props.type == '2-4'" :is_verifity="props.type == '2-3'" />
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useRegisterStore } from '@/stores/RegisterStore';
import { useGlobalStore } from '@/stores/GlobalStore';
import { useNotification } from '@shared/components/ui/notification';
import ConnectSocialDialog from '@shared/components/settings/ConnectSocialDialog.vue';
import DisConnectDialog from '@shared/components/settings/DisConnectDialog.vue';
import HandleSelector from '@/components/settings/HandleSelector.vue';
import ajax from '@/utils/Ajax';
import emitter from '@shared/utils/EventBus';

const props = defineProps({
  type: {
    type: String,
    default: '2-3', //2-4
  },
});
const emit = defineEmits(['updateHandle']);
const dialogVisible = ref(false);
const { openNotBottom } = useNotification();
const RegisterStore = useRegisterStore();
const store = useGlobalStore();
const dialogConnectValue = ref({
  open: false,
  data: null,
  step: 2,
});

const hasSuggestions = computed(() => RegisterStore.verifityList.some(item => item.handle));
const handleSelectorRef = ref(null);
const disConnectDialogRef = ref(null);
const disConnectItem = ref(null);

const connectPopup = (item) => {
  dialogConnectValue.value.open = true;
  dialogConnectValue.value.data = item;
  if (item.status === 10 || item.status === 15) {
    dialogConnectValue.value.step = 1;
  } else {
    dialogConnectValue.value.step = 2;
  }
  window.localStorage.setItem('CREATOR_PROTAL_new_add_social', true);
};

const updateHandle = (val) => {
  emit('updateHandle', val);
};

const openDisConnectDialog = (item) => {
  disConnectItem.value = item;
  disConnectDialogRef.value.open();
};

const handleDisconnect = async () => {
  let date = {
    social_platform: disConnectItem.value.social_platform,
    handle: disConnectItem.value.handle,
  };
  RegisterStore.loading = true;
  ajax.post('/disconnect-social-account', date).then(async () => {
    openNotBottom(`${disConnectItem.value.name} connection removed`, 'success');
    disConnectDialogRef.value.close();
    setTimeout(async () => {
      await RegisterStore.handleRegisterSocial();
    }, 1000);
  }).catch(() => {
    RegisterStore.loading = false;
    openNotBottom('Connection removed fail', 'error');
  });
};

defineExpose({
  open: () => { dialogVisible.value = true; },
  close: () => { dialogVisible.value = false; },
  confirmHandle: () => handleSelectorRef.value?.confirmHandle(),
});

onMounted(() => {
  window.localStorage.removeItem('CREATOR_PROTAL_motom_register_step');
  emitter.on('open-connect-dialog', () => {
    dialogVisible.value = true;
  });
});

onUnmounted(() => {
  emitter.off('open-connect-dialog');
});
</script>

<style lang="scss">
.connect-box {
  width: 100%;
  @include flexCenter();
  flex-wrap: wrap;
  gap: 16px;

  .connect-line {
    @include flexCenter();
    justify-content: center;
    width: 100%;

    .social {
      flex: 1;
      font-size: 16px;
      color: var(--Text-primary);
      @include flexCenter();
      gap: 8px;

      .svg-icon {
        width: 24px;
        height: 24px;
        fill: var(--Text-primary);
      }
    }
  }
}

.suggestion-block {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  background: var(--Black-20);
  border-radius: 4px;
  padding: 8px;
  box-sizing: border-box;

  .suggestion-icon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    margin-top: 2px;
  }

  .suggestion-text {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 2px;
    font-size: 13px;
    color: var(--Text-primary);
    line-height: 1.5;

    span:first-child {
      color: var(--Text-primary);
      font-weight: 500;
    }
  }
}

.handle-select-box{
  display: grid;
  gap:8px;
  width: 100%;
}
</style>
